import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from 'axios';
import { TailSpin } from  'react-loader-spinner';
import Colors from '../library/Colors';
import './logging/logging.css';
import SftGlobalData from '../library/SftGlobalData';
import AddIcon from '@mui/icons-material/Add';
import MySoftTouch from '../assets/application-icons/ic_mysft.png';
import MySales from '../assets/application-icons/ic_mysales.png';
import MyFashionManager from '../assets/licence-icons/office.png';
import Consultation from '../assets/mobile-icons/ic_consultation.png';
import Collection from '../assets/licence-icons/collection.png';
import Cloud from '../assets/licence-icons/cloud.png';
import MyFasmanMobile from '../assets/module-icons/ic_mobile.png';
import MyFasmanRevenue from '../assets/application-icons/ic_revenue.png';
import Webshop from '../assets/mobile-icons/ic_webshop.png';
import Integrations from '../assets/licence-icons/integrations.png';
import Hardware from '../assets/licence-icons/hardware.png';
import Others from '../assets/licence-icons/other.png';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';
import Button from '@mui/material/Button';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PersonIcon from '@mui/icons-material/Person';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import UpdateIcon from '@mui/icons-material/Update';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import TemplateScreen from './template/TemplateScreen';
import crypto from 'crypto-js';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrash, faCheckCircle, faCopy, faLink } from '@fortawesome/free-solid-svg-icons';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { surface } from './timeclock/tcFormat';
import { ApprovalFilter, AppChip, DocsSearch, approvalMode } from './docs/DocsParts';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <div>{children}</div>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  

function LinkCell (props) {
    return (<Link to={"/"+props.lang+"/manuals/view/"+props.id} style={{width: '100%', height: '100%', alignContent: 'center', alignItems: 'center', display: 'flex'}}>{props.children}</Link>)
}

const ManualScreen = (props) =>  {
    const [loading, setLoading] = useState(true);
    const [searchValue, setSearchValue] = useState("");
    const [applications, setApplications] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [applicationFilter, setApplicationFilter] = useState("");
    const [includeApproved, setIncludeApproved] = useState(true);
    const [onlyApproved, setOnlyApproved] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    // Tabs: 0 manuals, 1 update logs, 2 templates (same audience as the former Templates menu item).
    const TAB_NAMES = ['manuals', 'updates', 'templates'];
    const canTemplates = props.login?.sft_status == "1" && (props.login?.sft_group === "ADMIN" || props.login?.sft_group === "SUPER");
    const [searchParams, setSearchParams] = useSearchParams();
    const chooseTab = (tab) => {
        const safe = tab === 2 && !canTemplates ? 0 : tab;
        setActiveTab(safe);
        sessionStorage.setItem('docTab', safe);
    };
    const initialGrid = getCookie("initialStateDocs") === "{}" ? {columns: {columnVisibilityModel: {},}} : JSON.parse(getCookie("initialStateDocs"));
    const gridColumns = [
        {
            field: 'icon',
            headerName: "",
            minWidth: 38,
            maxWidth: 50,
            headerAlign: 'left',
            align: 'left',    
            display: 'flex',
            renderCell: (params) => {
                return <LinkCell id={params.row.id} lang={params.row.lang} theme={params.row.theme} ><img alt={params.row.title + " icon"} src={params.row.icon}  style={{objectFit: 'contain', height: '32px', width: '32px'}} loading={"lazy"} /></LinkCell>}
        },
        {
            field: 'title',
            headerName: props.t('manual'),
            minWidth: 300,
            headerAlign: 'left',
            align: 'left',      
            display: 'flex',  
            renderCell: (params) => {
                return <LinkCell id={params.row.id} lang={params.row.lang} theme={params.row.theme} ><span>{params.row.title}</span></LinkCell>}
        },
        {
            field: 'type',
            headerName: props.t('type'),
            minWidth: 50,
            maxWidth: 75,  
            headerAlign: 'center',
            align: 'center',
            display: 'flex',
            renderCell: (params) => {
                return params.row.type === "VERSION" ? <UpdateIcon style={{color: Colors.sft_blue}}/> : <LibraryBooksIcon style={{color: Colors.sft_blue}}/>
                }
        },
        {
            field: 'visibility',
            headerName: props.t('visibility'),
            minWidth: 50,    
            maxWidth: 75,  
            align: 'center',      
            headerAlign: 'center', 
            display: 'flex',
            renderCell: (params) => {
              return params.row.visibility === "INTERNAL" ? <SupportAgentIcon style={{color: Colors.sft_blue}}/> : (params.row.visibility === "DEV" ? <IntegrationInstructionsIcon style={{color: Colors.sft_blue}}/> : <PersonIcon style={{color: Colors.sft_blue}}/>)
              }
        },
        {
            field: 'sort',
            headerName: props.t('sort'),
            minWidth: 100,    
            maxWidth: 120,  
            numeric: true,
            type: 'number',
            align: 'center',      
            headerAlign: 'center',
            display: 'flex',
        },
        {
            field: 'tags',
            headerName: props.t('tags'),
            minWidth: 200,
            headerAlign: 'left',
            align: 'left',
            display: 'flex',
        },
        {
            field: 'owner',
            headerName: props.t('owner'),
            minWidth: 150,
            headerAlign: 'left',
            align: 'left',
            display: 'flex',
            renderCell: (params) => {
                return <span>{params.row.owner_name || '-'}</span>
            }
        },
        {
            field: 'versions',
            headerName: props.t('versions'),
            minWidth: 100,
            headerAlign: 'center',
            align: 'center',
            display: 'flex',
            renderCell: (params) => {
                return <span>{params.row.version_count || 1} {params.row.has_draft && <span style={{color: Colors.def_orange}}> (+{props.t('draft')})</span>}</span>
            }
        },
        {
            field: 'edit',
            headerName: props.t('edit'),
            minWidth: 60,    
            maxWidth: 60,  
            align: 'center',      
            headerAlign: 'center', 
            display: 'flex',
            renderCell: (params) => {
            return  ((props.login.sft_group === "ADMIN" || props.login.sft_group === "SUPER") || props.login.id === params.row.created_by) ? <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={()=>{navigate("/"+props.lang+"/manuals/edit/"+params.row.id)}} >
                        <FontAwesomeIcon icon={faPencilAlt} color={Colors.def_orange} size="2x" />
                    </Button> : <div></div>;        
            }
        },
        {
            field: 'copy',
            headerName: props.t('copy'),
            minWidth: 60,    
            maxWidth: 60,  
            align: 'center',      
            headerAlign: 'center', 
            renderCell: (params) => {
              return  <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={()=>{onDuplicateManual(params.row.id)}} ><FontAwesomeIcon icon={faCopy} color={Colors.def_grey} size="2x" /></Button>
              }
        },
        {
            field: 'delete',
            headerName: "",
            minWidth: 60,    
            maxWidth: 60,  
            align: 'center',      
            headerAlign: 'center', 
            display: 'flex',
            renderCell: (params) => {
              return  (props.login.sft_group === "ADMIN" || props.login.sft_group === "SUPER") ? <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={()=>{onDeleteManual(params.row.id)}} >
                          <FontAwesomeIcon icon={faTrash} color={Colors.def_red} size="2x" />
                      </Button> : <div></div>;        
              }
        },
        {
              field: 'confirm',
              headerName: "",
              minWidth: 60,    
              maxWidth: 60,  
              align: 'center',      
              headerAlign: 'center',
              display: 'flex', 
              renderCell: (params) => {
                return  (params.row.confirmed === 0 && (props.login.sft_group === "ADMIN" || props.login.sft_group === "SUPER")) ? <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={()=>{onActivateManual(params.row.id)}} ><FontAwesomeIcon icon={faCheckCircle} color={Colors.def_green} size="2x" /></Button>
                                                   : <div></div>
                }
        },
        {
            field: 'link',
            headerName: "",
            minWidth: 60,    
            maxWidth: 60,  
            align: 'center',      
            headerAlign: 'center', 
            display: 'flex',
            renderCell: (params) => {
              return  (params.row.type === "VERSION" && (props.login.sft_group === "ADMIN" || props.login.sft_group === "SUPER")) ? <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={()=>{documentLink(params.row)}} ><FontAwesomeIcon icon={faLink} color={Colors.def_grey} size="2x" /></Button>
                                                 : (params.row.type !== "VERSION" ? <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={()=>{manualLink(params.row)}} ><FontAwesomeIcon icon={faLink} color={Colors.def_grey} size="2x" /></Button> : <div></div>)
              }
      },
      {
            field: 'available_languages',
            headerName: props.t('availableLanguages'),
            minWidth: 150,
            headerAlign: 'left',
            align: 'left',
            display: 'flex',
            renderCell: (params) => {
                return <span>{params.row.available_languages?.join(', ')}</span>
            }
      }
      ];
    let navigate = useNavigate();

    const documentLink = (doc) => {
        let hash = crypto.MD5(parseInt((new Date(doc.created_at).getTime() / 1000).toFixed(0))+"-"+doc.id).toString();
        navigator.clipboard.writeText("https://changelog.softtouch.eu/"+props.lang+"/red/"+hash);
        props.notify(props.t('copied') + " changelog URL", 2000, "top-right", props.theme, 1); 
        
    }

    // Same link the former "Updates" item in the logging sidebar opened.
    const openChangelog = () => {
        window.open('https://changelog.softtouch.eu/' + props.lang + '/mysft/' + crypto.AES.encrypt(JSON.stringify({is_valid: props.login.is_valid, sft_group: props.login.sft_group, sft_status: props.login.sft_status, sft_user_id: props.login.sft_user_id}), 'Soft295Touch!').toString().replaceAll("/", "DIRTY_SLASH_FIX"), '_blank');
    }

    const manualLink = (doc) => {
        navigator.clipboard.writeText("https://my.softtouch.eu/"+props.lang+"/authentication/"+SftGlobalData.defaultKey+"/kb/"+doc.id);
        props.notify(props.t('copied') + " manual URL", 2000, "top-right", props.theme, 1); 
        
    }

    useEffect(() => {
        props.changeScreen('logging');
        try{
            let sessionApproved = sessionStorage.getItem('approved');
            let sessionSearch = sessionStorage.getItem('docSearch');
            let sessionFilter = sessionStorage.getItem('docApp');
            let sessionTab = sessionStorage.getItem('docTab');

            if(sessionApproved !== null){setIncludeApproved(sessionApproved === 'true');}
            if(sessionSearch !== null){setSearchValue(sessionSearch);}
            if(sessionFilter !== null){setApplicationFilter(sessionFilter);}
            // ?tab=templates (old /templates links, back from the template editor) wins over the remembered tab.
            const queryTab = TAB_NAMES.indexOf(searchParams.get('tab'));
            if(queryTab !== -1){
                chooseTab(queryTab);
                setSearchParams({}, { replace: true });
            } else if(sessionTab !== null){
                chooseTab(parseInt(sessionTab) || 0);
            }
        }catch(ex){}

        SftGlobalData.post('docs&action=fetchApplications', {sft_id: props.login.sft_id, sft_group: props.login.sft_group, login: props.login.login}).then(response => {      
            setApplications(response.data);
        });

        fetchHeaders();
      }, [props.api, props.login]);
      

      const fetchHeaders = () => {
        SftGlobalData.post('docs&action=fetchHeaders', {sft_id: props.login.sft_id, sft_group: props.login.sft_group, login: props.login.login}).then(response => { 
            setHeaders(Array.isArray(response.data) ? response.data : []);
            setLoading(false);
        });
      }

      const pickApplication = (id) => {
          const next = id === "" || id == applicationFilter ? "" : id;
          setApplicationFilter(next);
          sessionStorage.setItem('docApp', next);
      };

      function getApplicationIcon(names){
        switch (names){
            case "1":
            case "MySales": 
                return MySales;
            case "2":
            case "MyFashionManager": 
                return MyFashionManager;
            case "3":
            case "Consultation": 
                return Consultation;
            case "4":
            case "Collection": 
                return Collection;
            case "5":
            case "Cloud": 
                return Cloud;
            case "6":
            case "MyFasman Mobile": 
                return MyFasmanMobile;
            case "7":
            case "MyFasman Revenue": 
                return MyFasmanRevenue;
            case "8":
            case "Webshop": 
                return Webshop;
            case "9":
            case "Integrations": 
                return Integrations;
            case "10":
            case "Hardware": 
                return Hardware;
            case "11":
            case "MySoftTouch":
                return MySoftTouch;
            default:
            case "12":
            case "Others": 
                return Others;       
        }
      }



const onDuplicateManual = (id) => {
    if (window.confirm(props.t('confirm_duplicate_document')) === true) {
        let postData = {
            sft_id: props.login.sft_id,
            sft_group: props.login.sft_group,
            login: props.login.login,
            id: id
        }
        SftGlobalData.post('docs&action=duplicate', postData).then(response => {       
            fetchHeaders();
        });
    }
}

const onActivateManual = (id) => {
    if (window.confirm(props.t('confirm_activate_document')) === true) {
        let postData = {
            sft_id: props.login.sft_id,
            sft_group: props.login.sft_group,
            login: props.login.login,
            id: id,
            active: true
        }

        SftGlobalData.post('docs&action=activate', postData).then(response => {      
            fetchHeaders();
        });
    }
}

const onDeleteManual = (id) => {
    if (window.confirm(props.t('confirm_delete_document')) === true) {
        let postData = {
            sft_id: props.login.sft_id,
            sft_group: props.login.sft_group,
            login: props.login.login,
            id: id
        }

        SftGlobalData.post('docs&action=delete', postData).then(response => {    
            fetchHeaders();
        });
    }
}


    const apiRef = useGridApiRef();
    
    
    useEffect(()=>{
        //console.log("adding subscriptions");
        try{
            apiRef.current.subscribeEvent(
                'columnOrderChange',
                ()=>{visibilityChangedHandler();},
            );
        }catch(ex){
    
        }
    }, [apiRef.current]);

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        //console.log("cookie", cname + "=" + cvalue + ";" + expires + ";path=/");
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "{}";
    }

    const visibilityChangedHandler = () => {
        let temp = apiRef.current.exportState();
        if(typeof temp.columns.columnVisibilityModel === "undefined"){
            temp.columns.columnVisibilityModel = {};
        }
        try{
            temp.preferencePanel.open = false;
        }catch(e){
    
        }
        try{
            delete temp.pagination;
        }catch(e){
            console.error(e);
        }
        setCookie("initialStateDocs", JSON.stringify(temp), 100000);
    }
    

  const s = surface(props.theme);
  const isAdmin = props.login.sft_group === "ADMIN" || props.login.sft_group === "SUPER";
  const tabCount = (tab) => headers.filter((row) => (tab === 0 ? row.type !== "VERSION" : row.type === "VERSION")).length;
  const pendingCount = (tab) => headers.filter((row) => row.active == "0" && (tab === 0 ? row.type !== "VERSION" : row.type === "VERSION")).length;
  const setApproval = (mode) => {
      setOnlyApproved(mode === 'pending');
      const include = mode !== 'approved';
      setIncludeApproved(include);
      sessionStorage.setItem('approved', include);
  };
  const tabLabel = (icon, label, count, pending) => (
      <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
          {icon}{label}
          {count !== null && <Box component="span" sx={{ fontSize: 12, fontWeight: 600, color: s.faint }}>{count}</Box>}
          {pending > 0 && (
              <Tooltip title={props.t('docs_filter_pending')}>
                  <Box component="span" sx={{ fontSize: 11.5, fontWeight: 700, color: '#fff', backgroundColor: Colors.def_orange, borderRadius: '10px', px: 0.8, lineHeight: '18px' }}>{pending}</Box>
              </Tooltip>
          )}
      </Box>
  );

  return (
    <div className="_100perc log__main_container log__padding_sidebar">
        {/* The card fills the window height (flex 1) and the grid takes what is left, so only the grid scrolls.
            minHeight auto (instead of the 710px from logging.css) keeps the card from shrinking below its content
            on small windows; then the page scrolls, as before. */}
        <div className={'log__container_content ' + props.theme + ' container_content_' + props.theme + ' box_fade-in'}
            style={{ flex: '1 1 auto', minHeight: 'auto', display: 'flex', flexDirection: 'column', boxSizing: 'border-box', marginBottom: 20 }}>
            <Box sx={{ p: { xs: 1, md: 2 }, flex: '1 1 auto', display: 'flex', flexDirection: 'column' }}>
                {/* Header */}
                <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 2, rowGap: 1.5, mb: 2, flexWrap: 'wrap' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mr: 'auto', minWidth: 0 }}>
                        <Box sx={{ width: 40, height: 40, borderRadius: '8px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: Colors.sft_blue, color: '#fff' }}>
                            <LibraryBooksIcon />
                        </Box>
                        <Box sx={{ minWidth: 0 }}>
                            <Typography component="h1" sx={{ fontSize: 21, fontWeight: 700, lineHeight: 1.25 }}>{props.t('documents')}</Typography>
                            <Typography sx={{ fontSize: 13, color: 'text.secondary', lineHeight: 1.4 }}>
                                {canTemplates ? props.t('docs_subtitle_templates') : props.t('docs_subtitle')}
                            </Typography>
                        </Box>
                    </Box>
                    <Tooltip title={props.t('open_changelog')}>
                        <IconButton onClick={openChangelog} aria-label={props.t('open_changelog')}
                            sx={{ width: 40, height: 40, borderRadius: '8px', border: '1px solid ' + (s.dark ? 'rgba(255,255,255,0.14)' : Colors.light_accent_darker), color: Colors.sft_blue }}>
                            <UpdateIcon />
                        </IconButton>
                    </Tooltip>
                </Box>

                {/* Tabs */}
                <Tabs value={activeTab} onChange={(e, v) => chooseTab(v)} variant="scrollable" scrollButtons="auto"
                    sx={{ mb: 2, minHeight: 44, borderBottom: s.line,
                        '& .MuiTab-root': { textTransform: 'none', minHeight: 44, fontSize: 14.5, fontWeight: 600, px: 2, color: 'text.secondary' },
                        '& .Mui-selected': { color: Colors.sft_blue + ' !important' },
                        '& .MuiTabs-indicator': { backgroundColor: Colors.sft_blue } }}>
                    <Tab value={0} label={tabLabel(<LibraryBooksIcon sx={{ fontSize: 19 }} />, props.t('manuals'), loading ? null : tabCount(0), isAdmin ? pendingCount(0) : 0)} />
                    <Tab value={1} label={tabLabel(<UpdateIcon sx={{ fontSize: 19 }} />, props.t('update_logs'), loading ? null : tabCount(1), isAdmin ? pendingCount(1) : 0)} />
                    {canTemplates && <Tab value={2} label={tabLabel(<FolderOpenIcon sx={{ fontSize: 19 }} />, props.t('templates'), null, 0)} />}
                </Tabs>

                {activeTab === 2 && canTemplates && (
                    <TemplateScreen embedded screen={props.screen} screenWidth={props.screenWidth} t={props.t} lang={props.lang} api={props.api} theme={props.theme} changeScreen={props.changeScreen} notify={props.notify} login={props.login} />
                )}

                {activeTab !== 2 && (
                    <>
                        {/* Toolbar: search, approval filter, new document */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 1.5 }}>
                            <DocsSearch t={props.t} value={searchValue} onChange={(v) => { setSearchValue(v); sessionStorage.setItem('docSearch', v); }} />
                            {isAdmin && <ApprovalFilter t={props.t} mode={approvalMode(includeApproved, onlyApproved)} onChange={setApproval} />}
                            <Button variant="contained" disableElevation startIcon={<AddIcon />} onClick={() => navigate("/" + props.lang + "/manuals/edit/+")}
                                sx={{ textTransform: 'none', height: 40, borderRadius: '8px' }}>
                                {props.t('docs_new')}
                            </Button>
                        </Box>

                        {/* Application filter */}
                        {applications?.length > 0 && (
                            <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap', mb: 1.5 }}>
                                <AppChip theme={props.theme} label={props.t('docs_all_apps')} selected={applicationFilter === ""} onClick={() => pickApplication("")} />
                                {applications.map((element) => (
                                    <AppChip key={element.id} theme={props.theme} label={element.name} icon={getApplicationIcon(element.name)}
                                        selected={applicationFilter == element.id} onClick={() => pickApplication(element.id)} />
                                ))}
                            </Box>
                        )}

                        {loading ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
                                <TailSpin height="40" width="40" color={Colors.sft_blue} ariaLabel="loading" />
                            </Box>
                        ) : (
                            <Box sx={{ ...s.card, overflow: 'hidden', flex: '1 1 0', minHeight: 320 }}>
                            <DataGridPro
                                  apiRef={apiRef}
                                  initialState={initialGrid}
                                  className={props.theme}
                                  style={{ height: '100%', border: 'none' }}
                                  columns={activeTab === 1 ? gridColumns.filter(col => col.field !== 'available_languages') : gridColumns}
                                  rows={headers.filter((row)=>( (onlyApproved ? row.active == "0" : (includeApproved ? true : row.active != "0")) && (activeTab === 0 ? row.type !== "VERSION" : row.type === "VERSION") && ((row.type?.match(new RegExp(searchValue, "i")) || row.visibility?.match(new RegExp(searchValue, "i")) || row.tag?.match(new RegExp(searchValue, "i")) || row.title_nl?.match(new RegExp(searchValue, "i")) || row.title_en?.match(new RegExp(searchValue, "i")) || row.title_fr?.match(new RegExp(searchValue, "i"))) && ((row.application_id == applicationFilter) || applicationFilter == "")))).map((row, index) => {return {
                                          id: row.id,
                                          lang: props.lang,
                                          title: (props.lang === "nl" ? row.title_nl : (props.lang === "fr" ? row.title_fr : row.title_en)),
                                          visibility: row.visibility,
                                          type: row.type,
                                          created_at: row.created_at,
                                          updated_at: row.updated_at,
                                          created_by: row.created_by,
                                          updated_by: row.updated_by,
                                          sort: row.sort,
                                          tags: row.tag,
                                          edit: "Edit",
                                          delete: "Delete",
                                          copy: "Copy",
                                          confirmed: row.active != "0" ? 1 : 0,
                                          icon: getApplicationIcon(row.application_id),
                                          owner_name: row.owner_name,
                                          owner_id: row.owner_id,
                                          version_count: row.version_count,
                                          has_draft: row.has_draft,
                                          available_languages: row.available_languages,
                                      }                          
                                  })} 
                                  onColumnWidthChange={()=>{visibilityChangedHandler();}}
                                  onColumnVisibilityModelChange={()=>{visibilityChangedHandler();}}
                                  onPreferencePanelClose={()=>{visibilityChangedHandler();}}
                                  rowThreshold={0}
                                  rowHeight={38}
                                  height={300}
                                  loading={loading}
                                  pagination={false}

                                  /> 
                            </Box>
                        )}
                    </>
                )}
            </Box>
        </div>
    </div>
  );
}

export default ManualScreen;
